import React, { useEffect, useState } from 'react';
import { Star, Clock, User, Play, Heart, ChevronRight, ShoppingBag, ShoppingCart, PersonStanding, UserRoundCheck, ClockArrowUp, Video, EllipsisVertical, FolderCheck, LibraryBig, SquareDashedMousePointer, DownloadCloud, Fan, Bookmark, PencilRuler, Paperclip, Bolt, Flame, Sheet, MessageSquareDot } from 'lucide-react';
import { ChevronLeft } from "lucide-react";
import fallback_img from "./img/fallback_img.jpg"

import loading_img from "./img/loadingImg.jpg"
import PlayerSideBar from './PlayerSideBar';
import YoutubeDefaultPlayer from '../VideoPlayer/YoutubeDefaultPlayer';
import YoutubeVideoPlayerWebUI from '../VideoPlayer/YoutubeVideoPlayerWebUI';
import VimeoVideoPlayerWebUI from '../VideoPlayer/VimeoVideoPlayerWebUI';
import VimeoDefaultPlayer from '../VideoPlayer/VimeoDefaultPlayer';
import UniversalVideoPlayer from '../VideoPlayer/UniversalVideoPlayerWebUI';
import { playerCard1Object } from './ExportPlayerCard1Object';
import { coursePageObject } from '../CoursePageDesign/ExportCoursePageObject';
import PlayerPageCardSubCourse from './PlayerPageCardSubCourse';

/**
 * CourseCard
 * A sleek, responsive course card built with Tailwind CSS.
 * Props:
 *  - course: {
 *      id, title, subtitle, author, duration (e.g. '3h 20m'),
 *      lessons (number), rating (0-5), reviews (number),
 *      image (url), tags: string[], price (string - 'Free' or '₹199'),
 *      progress (0-100) optional
 *    }
 *  - onEnroll(courseId)
 *  - layout: 'compact' | 'regular' (optional)
 *
 * Default export is the component. This file uses Tailwind utility classes.
 */

export default function PlayerCardV1({  course, onEnroll = () => {}, layout = 'regular' }) {
  const {
    id,
    title = 'Untitled Course',
    subtitle = '',
    author = 'Unknown',
    duration = '',
    lessons = 0,
    rating = 0,
    reviews = 0,
    image = 'https://placehold.co/600x400?text=Course+Image',
    tags = [],
    price = 'Free',
    progress = null,
  } = course || {};

const [ showLeftQueBar, setShowLeftQueBar] = useState(true);
const [ openCurriculum, setOpenCurriculum] = useState(true);
const [ openSubCourse, setOpenSubCourse] = useState(false);
const [ openQnA, setOpenQnA] = useState(false);

  const showProgress = typeof progress === 'number' && progress >= 0 && progress <= 100;
const ImageFallFB = ({ itemOuter,boxShadow,src,width,aspectRatio, borderRadius,border,paddingLeft,paddingRight}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);
  
     
          const [reloadItems, setReloadItems] = useState(true);
         
             useEffect(()=>{
                 setReloadItems(false); setReloadItems(true);
                 
             },[ ])

               
  return (<>  
 <div  style={{padding:"2px",}}>
    <div style={{ position: "relative",boxShadow:boxShadow,
    overflow: "hidden",aspectRatio: aspectRatio,padding:"0px",border:border, 
     borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
    width:`${width}%`}}  className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}>
      {!isLoaded && !hasError && (
        <div
         style={
             { 
              borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
      aspectRatio: aspectRatio,
      objectFit: "cover",  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
        >
          <img
        src={loading_img}
        alt=""
      
       style={
             {
             borderTopLeftRadius:`${borderRadius?.topLeft?.value}${borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${borderRadius?.topRight?.value}${borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${borderRadius?.bottomLeft?.value}${borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${borderRadius?.bottomRight?.value}${borderRadius?.bottomRight?.resolution}`,
              
                position: "absolute",border:border,
      top: 0,
      left: 0,
      width: `${width}%`,padding:"10px",
    
      objectFit: "cover", aspectRatio: aspectRatio,  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
        </div>
      )}
      
      <img

      
        src={hasError ? fallback_img : src}
        alt=""
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
       style={
             {
                position: "absolute",
      top: 0,
      left: 0,
      width: `${width}%`,
     
      objectFit: "cover",aspectRatio: aspectRatio  }}
       className={`Theme1InfoCard1-CardImage-AspectRatioXs${itemOuter?.myKey}`}
      />
    </div>
</div>
   
  
   

    
    </>
  );
};
  return (

    <>   <div className="ty-root">
      <style>{`



.player-card__title{
  margin: 0;
  font-size: 18px;
  line-height: 1.15;
  color: ${playerCard1Object?.courseTitle?.titleColor?.color};
  font-family:${playerCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
}
  
.player-cardHeaderFont{
  font-family:${playerCard1Object?.titleFonts?.headerFont?.family?.fontFamily};;
}

.player-cardTitleFont{
  font-family:${playerCard1Object?.titleFonts?.titleFont?.family?.fontFamily};;
}
.player-cardSubTitleFont{
  font-family:${playerCard1Object?.titleFonts?.subtitleFont?.family?.fontFamily};;
}
  .player-cardTagsFont{
  font-family:${playerCard1Object?.titleFonts?.tagsFont?.family?.fontFamily};;
}.player-cardButtonFont{
  font-family:${playerCard1Object?.titleFonts?.buttonFont?.family?.fontFamily};;
}
.player-card__subtitle{
  margin: 6px 0 0;
  color: var(--muted);
  
  color: ${playerCard1Object?.courseTitle?.subtitleColor?.color};
  font-family:${playerCard1Object?.courseTitle?.subtitleFont?.family?.fontFamily};;
  font-size: 13px;
}


.player-card__progress{
  margin-top: 12px;
}

.player-card__progress-row{
  display:flex;
  justify-content: space-between;
  font-size: 12px; 
  font-family:${playerCard1Object?.courseTitle?.titleFont?.family?.fontFamily};;
  color: ${playerCard1Object?.courseTitle?.metaColor?.color};
}

.player-card__progress-bar{
  height: 8px;
  background: ${playerCard1Object?.lessonCard?.progressBarColor?.color};
  border-radius: 999px;
  overflow: hidden;
  margin-top: 6px;
}

.player-card__progress-fill{
  height: 100%;
  background: ${playerCard1Object?.lessonCard?.progressBarInnerColor?.color};;
}


.player-card__wishlist,.player-card__cart{background: ${playerCard1Object?.lessonCardButtons?.btnColor?.color?playerCard1Object?.lessonCardButtons?.btnColor?.color:"#222222"};
 
  border:${playerCard1Object?.lessonCardButtons?.border?.borderWidth?.value}px ${playerCard1Object?.lessonCardButtons?.border?.borderType} ${playerCard1Object?.lessonCardButtons?.border?.borderColor?.color};
  
  
           border-top-left-radius:${playerCard1Object?.lessonCardButtons?.borderRadius?.topLeft?.value+"px"};
    border-bottom-left-radius:${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomLeft?.value+"px"};
    border-top-right-radius:${playerCard1Object?.lessonCardButtons?.borderRadius?.topRight?.value+"px"};
    border-bottom-right-radius:${playerCard1Object?.lessonCardButtons?.borderRadius?.bottomRight?.value+"px"};
 padding:5px;width:70px;height:30px;
 display:flex;justify-content:center;align-items:center;gap:2px;
  font-weight: 700;
  cursor: pointer;}
/* Responsive tweaks */
@media (max-width: 520px){
  .player-card{ max-width: 100%; }
  .player-card__media{ height: 160px; }
  .player-card__title{ font-size: 16px; }
}
    
     
     
     
        .PlayerV1Right{position:fixed;top:0px;
        left:28%;
        right:0%;bottom:0px;
   padding:0px;z-index:9999999999 !important;
       
        top:0%;
        padding:0px;
       }
       .PlayerV1Left{position:fixed;top:0px;
        border:10px solid  rgba(144, 202, 249,0.11) ;
       left:0%;
        right:72%;bottom:0px !important;;
       
        top:0%;
        padding:5px;
        z-index:9999999999 !important;
       }
         .sidebarCardOuter{
   padding:5px;z-index:9999999999 !important;
    
    } 
      .sidebarCardOuterLeft{overflow-y:auto;max-height:90vh;
   padding:5px;z-index:9999999999 !important;
    
    }  
     .sidebarCardTop{
   padding:0px;gap:1px;
    display:flex;min-width:180px;width:100%;margin-bottom:10px;
    justify-content:space-between;
   }.sidebarCardTopBtns{cursor:pointer;
   border:2px solid rgba(144, 202, 249,0.81); display:flex;justify-content:left;align-items:center;
  padding:15px;border:2px solid rgba(144, 202, 249,0.81);
    min-width:65px;width:100%;height:0px;gap:10px;
    font-weight:900;
    
   }.sidebarCardTopBtnTwo,.sidebarCardTopBtnThree{cursor:pointer;
   border:2px solid rgba(144, 202, 249,0.11);padding:15px;
    display:flex;width:20px;height:0px;
    justify-content:space-between;
   }
     .topVideoLessonName{font-size:16px;}
      .PlayerV1Outer{position:fixed;top:0px;
        left:0%;
        right:0%;bottom:0px;
        
        top:0%;
        padding:0px;
        z-index:9999999999;
       }
         /* sm */
@media (min-width: 768px) and (max-width: 991px) {
   
     .PlayerV1Right{
        left:38%;
       }
       .PlayerV1Left{
        right:62%;
       } 
      }
       

/* md */
@media (min-width: 992px) and (max-width: 1199px) {
     .PlayerV1Right{
        left:35%;
        right:0%;
       }
       .PlayerV1Left{
       left:0%;
        right:65%;
       }
      }


/* xs */
@media (max-width: 767px) {
 .PlayerV1Right{
        left:0% !important;
       } .PlayerV1Left{
        left:0%;right:0%;
       }
        .topVideoLessonName{font-size:12px;}
        .sidebarCardTopBtnThree{padding:10px;margin-top:10px;
    
   }
     
        }
     
     `}</style>





  <div   className="PlayerV1Outer" >
             

      {!showLeftQueBar? <div style={{background:"rgba(144, 202, 249,0.51)",width:"15px",height:"50px",borderRadius:"5px",position:"absolute",left:"0px",top:"0px",
                    display:"flex",justifyContent:"center",alignItems:"center",textAlign:"center",padding:"0px",margin:"5px",cursor:"pointer"}} onClick={()=>setShowLeftQueBar(true)} ><ChevronRight   size={25}  color="#ffffff"/></div> 
:""}

 <div   className={!showLeftQueBar? "":"PlayerV1Right"} 
 style={{background:"#ffffff"}}>
    {showLeftQueBar? <div   className="PlayerV1Left " style={{ 
     borderTopLeftRadius:`${playerCard1Object?.sidebarCard?.borderRadius?.topLeft?.value}${playerCard1Object?.sidebarCard?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.sidebarCard?.borderRadius?.topRight?.value}${playerCard1Object?.sidebarCard?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.sidebarCard?.borderRadius?.bottomLeft?.value}${playerCard1Object?.sidebarCard?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.sidebarCard?.borderRadius?.bottomRight?.value}${playerCard1Object?.sidebarCard?.borderRadius?.bottomRight?.resolution}`,border:` 
${playerCard1Object?.sidebarCard?.border?.borderWidth?.value+playerCard1Object?.sidebarCard?.border?.borderWidth?.resolution} ${playerCard1Object?.sidebarCard?.border?.borderType}  ${playerCard1Object?.sidebarCard?.border?.borderColor?.color}
  `,background:`${playerCard1Object?.sidebarCard?.layoutBG?.color}`,}}> 
       <div className="sidebarCardTop" style={{ }}>
          <div onClick={()=>{setOpenCurriculum(true);setOpenSubCourse(false);setOpenQnA(false)}} className="sidebarCardTopBtns" style={{
     borderTopLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.topLeft?.value}${playerCard1Object?.topBar?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.topBar?.borderRadius?.topRight?.value}${playerCard1Object?.topBar?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.value}${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomRight?.value}${playerCard1Object?.topBar?.borderRadius?.bottomRight?.resolution}`,border:` 
${playerCard1Object?.topBar?.border?.borderWidth?.value+playerCard1Object?.topBar?.border?.borderWidth?.resolution} ${playerCard1Object?.topBar?.border?.borderType}  ${playerCard1Object?.topBar?.border?.borderColor?.color}
  `,background:`${playerCard1Object?.topBar?.bgColor?.color}`,}}>
            <SquareDashedMousePointer size={26} color={playerCard1Object?.topBar?.iconColor?.color} />
            <span className='player-cardButtonFont'
             style={{fontSize:"12px",color:`${playerCard1Object?.topBar?.textColor?.color}`}}>{playerCard1Object?.topBar?.title1}</span>

   </div> <div onClick={()=>{setOpenCurriculum(false);setOpenSubCourse(true);setOpenQnA(false)}}  className="sidebarCardTopBtns" style={{
     borderTopLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.topLeft?.value}${playerCard1Object?.topBar?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.topBar?.borderRadius?.topRight?.value}${playerCard1Object?.topBar?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.value}${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomRight?.value}${playerCard1Object?.topBar?.borderRadius?.bottomRight?.resolution}`,border:` 
${playerCard1Object?.topBar?.border?.borderWidth?.value+playerCard1Object?.topBar?.border?.borderWidth?.resolution} ${playerCard1Object?.topBar?.border?.borderType}  ${playerCard1Object?.topBar?.border?.borderColor?.color}
  `,background:`${playerCard1Object?.topBar?.bgColor?.color}`,}}>
   <FolderCheck size={26} color={playerCard1Object?.topBar?.iconColor?.color} />
            <span className='player-cardButtonFont'
             style={{fontSize:"12px",color:`${playerCard1Object?.topBar?.textColor?.color}`}}>{playerCard1Object?.topBar?.title2}</span></div> 
            <div onClick={()=>{setOpenCurriculum(false);setOpenSubCourse(false);setOpenQnA(true)}}  className="sidebarCardTopBtnTwo"style={{
     borderTopLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.topLeft?.value}${playerCard1Object?.topBar?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.topBar?.borderRadius?.topRight?.value}${playerCard1Object?.topBar?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.value}${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomRight?.value}${playerCard1Object?.topBar?.borderRadius?.bottomRight?.resolution}`,border:` 
${playerCard1Object?.topBar?.border?.borderWidth?.value+playerCard1Object?.topBar?.border?.borderWidth?.resolution} ${playerCard1Object?.topBar?.border?.borderType}  ${playerCard1Object?.topBar?.border?.borderColor?.color}
  `,background:`${playerCard1Object?.topBar?.bgColor?.color}`,justifyContent:"center",alignItems:"center"}}>
     <LibraryBig size={26} color={playerCard1Object?.topBar?.iconColor?.color} />
   </div> <div onClick={()=>{setShowLeftQueBar(false)}} className="sidebarCardTopBtnTwo" style={{
     borderTopLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.topLeft?.value}${playerCard1Object?.topBar?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.topBar?.borderRadius?.topRight?.value}${playerCard1Object?.topBar?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.value}${playerCard1Object?.topBar?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.topBar?.borderRadius?.bottomRight?.value}${playerCard1Object?.topBar?.borderRadius?.bottomRight?.resolution}`,border:` 
${playerCard1Object?.topBar?.border?.borderWidth?.value+playerCard1Object?.topBar?.border?.borderWidth?.resolution} ${playerCard1Object?.topBar?.border?.borderType}  ${playerCard1Object?.topBar?.border?.borderColor?.color}
  `,
    background:`${playerCard1Object?.topBar?.iconColor?.color}`,justifyContent:"center",alignItems:"center"}}>
     <ChevronLeft size={16} color={"#ffffff"} />
   </div> 
   </div> 
   <div style={{overflowY:"auto",overflowX:"hidden",maxHeight:"90vh"}}>
             {/* <div style={{background:"rgba(144, 202, 249,0.51)",width:"15px",height:"50px",borderRadius:"5px",position:"absolute",right:"-20px",top:"0px",
                    display:"flex",justifyContent:"center",alignItems:"center",padding:"0px",margin:"5px",zIndex:9999999999,cursor:"pointer"}} onClick={()=>setShowLeftQueBar(false)} ><ChevronLeft size={25}  color="#ffffff"/></div>  */}
 {openCurriculum?<><h2>Curriculum</h2>
 <PlayerSideBar setShowLeftQueBar={()=>{setShowLeftQueBar(false)}} playerCard1Object={playerCard1Object} /></>:""}
 {openSubCourse?<><h2>Subcourses</h2>
 <PlayerPageCardSubCourse coursePageObject={coursePageObject}/></>:""}
 {openQnA?<><h2>QnA</h2></>:""}
{/* <PlayerSideBar setShowLeftQueBar={()=>{setShowLeftQueBar(false)}} playerCard1Object={playerCard1Object} /> */}

  


   </div>
   </div>:""} 
   
    <div  className="sidebarCardOuter" style={{ 
    border:` 
${playerCard1Object?.playerCard?.border?.borderWidth?.value+playerCard1Object?.playerCard?.border?.borderWidth?.resolution} ${playerCard1Object?.playerCard?.border?.borderType}  ${playerCard1Object?.playerCard?.border?.borderColor?.color}
  `,background:`${playerCard1Object?.playerCard?.layoutBG?.color}`}} >
      
     <div className="sidebarCardTop" style={{}}>
      <div style={{display:"flex",justifyContent:"left",alignItems:"center",gap:"5px",marginTop:"-5px"}}>
    <Video size={26} color={playerCard1Object?.progressBar?.textColor?.color} />
    <div className='topVideoLessonName' style={{fontWeight:"800",margin:"0px",color:`${playerCard1Object?.progressBar?.textColor?.color}`}}>Lesson 1</div>
    </div>
         <div className="player-card__progress"style={{width:"60%",marginTop:"0px"}}>
<div className="player-card__progress-row">
<span className='topVideoLessonName ' style={{fontWeight:"800",color:`${playerCard1Object?.progressBar?.textColor?.color}`}}>{playerCard1Object?.progressBar?.title}</span>
<span style={{color:`${playerCard1Object?.progressBar?.textColor?.color}`}}>{progress}%</span>
</div>
<div className="player-card__progress-bar">
<div className="player-card__progress-fill" style={{ width: `${progress}%` }} />
</div>
</div>  <div onClick={()=>{}} className="sidebarCardTopBtnThree" style={{borderRadius:"15px",background:`${playerCard1Object?.lessonCard?.progressBarInnerColor?.color}`,justifyContent:"center",alignItems:"center"}}>
     <EllipsisVertical size={36} color={playerCard1Object?.progressBar?.textColor?.color} />
   </div> 
   </div> 
   <div style={{overflowY:"auto",height:"92vh"}}>
{playerCard1Object?.video?.sourceType=="youtube"?
       !playerCard1Object?.video?.youtube?.useDefaultPlayer?<YoutubeVideoPlayerWebUI  videoSettings={playerCard1Object?.video} videoId={playerCard1Object?.video?.youtube?.src} minHeight={670} maxHeight={690}/>
       :<YoutubeDefaultPlayer videoSettings={playerCard1Object?.video}   videoId={playerCard1Object?.video?.youtube?.src} minHeight={670} maxHeight={690}/>
       :playerCard1Object?.video?.sourceType=="vimeo"?
       !playerCard1Object?.video?.vimeo?.useDefaultPlayer?<VimeoVideoPlayerWebUI  videoSettings={playerCard1Object?.video} videoId={playerCard1Object?.video?.vimeo?.src} minHeight={670} maxHeight={690}/>
       :<VimeoDefaultPlayer videoSettings={playerCard1Object?.video}   videoId={playerCard1Object?.video?.vimeo?.src} minHeight={670} maxHeight={690}/>
       :playerCard1Object?.video?.sourceType=="mp4URL"?
       <UniversalVideoPlayer videoSettings={playerCard1Object?.video}   videoUrl={playerCard1Object?.video?.mp4URL?.src} minHeight={670} maxHeight={690}/>:
       ""}

{/* <div className="" style={{background:`${playerCard1Object?.playerButtons?.bgColor?.color}`,
border:` ${playerCard1Object?.playerButtons?.border?.borderWidth?.value+playerCard1Object?.playerButtons?.border?.borderWidth?.resolution} ${playerCard1Object?.playerButtons?.border?.borderType}  ${playerCard1Object?.playerButtons?.border?.borderColor?.color}`,
 borderTopLeftRadius:`${playerCard1Object?.playerButtons?.borderRadius?.topLeft?.value}${playerCard1Object?.borderRadius?.topLeft?.resolution}`,
              borderTopRightRadius:`${playerCard1Object?.playerButtons?.borderRadius?.topRight?.value}${playerCard1Object?.playerButtons?.borderRadius?.topRight?.resolution}`,
              borderBottomLeftRadius:`${playerCard1Object?.playerButtons?.borderRadius?.bottomLeft?.value}${playerCard1Object?.playerButtons?.borderRadius?.bottomLeft?.resolution}`,
              borderBottomRightRadius:`${playerCard1Object?.playerButtons?.borderRadius?.bottomRight?.value}${playerCard1Object?.playerButtons?.borderRadius?.bottomRight?.resolution}`,
             marginTop:"15px", marginBottom:"15px",padding:"5px"}}>
    <div >
    <div style={{display:"flex",justifyContent:"space-around",alignItems:"center",gap:"5px"}}>
       
    <div style={{fontSize:"12px",fontWeight:"800",margin:"0px",width:"75px",display:"flex",justifyContent:"space-around",alignItems:"center",gap:"5px"}}>  
      <Flame size={26} color={playerCard1Object?.playerButtons?.iconColor?.color} />
  <span className='player-cardButtonFont' style={{color:playerCard1Object?.playerButtons?.textColor?.color}} >{playerCard1Object?.playerButtons?.title1}</span>
  </div>
 <div  style={{fontSize:"12px",fontWeight:"800",margin:"0px",display:"flex",justifyContent:"space-around",alignItems:"center",gap:"5px"}}>  
      <Bookmark size={26} color={playerCard1Object?.playerButtons?.iconColor?.color} />
  <span className='player-cardButtonFont' style={{color:playerCard1Object?.playerButtons?.textColor?.color}} > {playerCard1Object?.playerButtons?.title2}</span></div> 
 <div  style={{fontSize:"12px",fontWeight:"800",margin:"0px",display:"flex",justifyContent:"space-around",alignItems:"center",gap:"5px"}}>  
      <PencilRuler size={26} color={playerCard1Object?.playerButtons?.iconColor?.color} />
  <span className='player-cardButtonFont' style={{color:playerCard1Object?.playerButtons?.textColor?.color}} > {playerCard1Object?.playerButtons?.title3}</span></div>
 <div  style={{fontSize:"12px",fontWeight:"800",margin:"0px",display:"flex",justifyContent:"space-around",alignItems:"center",gap:"5px"}}>  
      <MessageSquareDot size={26} color={playerCard1Object?.playerButtons?.iconColor?.color} />
  <span className='player-cardButtonFont' style={{color:playerCard1Object?.playerButtons?.textColor?.color}} >  {playerCard1Object?.playerButtons?.title4}</span></div> 
</div>
    </div>    </div> */}
   

</div> 

   </div>
    </div> 
   </div> 

</div>

    </>
  );
}
